var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"header"},[_c('div',{staticStyle:{"max-width":"500px","margin":"15px"}},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticStyle:{"max-width":"100%","width":"100%"},attrs:{"src":"/assets/img/logo-hp.png"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }